/*---------------------------------------*

	API HANDLER

----------------------------------------*/

window.apiHandler = {

	/*---------------------------------------*
		BASE URL
	----------------------------------------*/

	url: false,

	getUrl: function(){
		return window.appSettings.getUrl();
	},

	getWGUrl: function(){
		return window.appSettings.getWGUrl();
	},

	getImageCloudUrl: function(){
		var url = "//res.cloudinary.com/desenio/image/upload/"; // The default url for local development
		return url;
	},

	/*---------------------------------------*
		GETTER
	----------------------------------------*/

 	get: function(postData, returnFunction, forceLive, dataType, fetchArticles = false){
 		var self = this;

		let isFetchingArticles = null

		// Prevent any duplicate requests
		if(window.vueInstance && fetchArticles) {

			isFetchingArticles = window.vueInstance.$store.state.isFetchingArticles;

			if(isFetchingArticles) {
				isFetchingArticles.abort()
			}
		}

		// Force live version
 		if(typeof forceLive == 'undefined')
 			var forceLive = false;

		// Datatype that will be used
 		if(typeof dataType == 'undefined')
 			var dataType = 'json';

 		// If using local enviroment
 		if(window.localEnviroment && !forceLive) {
			$.ajax({
				type: "post",
				url: "https://desenio.se/includes/backend/apiTaker.php",
				async: true,
				dataType: dataType,
				data: postData,
				beforeSend: function(data) {
				if(fetchArticles)
					window.vueInstance.$store.commit('sendingApiRequest', data)

				},
				success: function (data){
				if(fetchArticles)
					window.vueInstance.$store.commit('sendingApiRequest', null)

				data = self.convertData(data);
				returnFunction(data);

				},
				error: function(e){
				if(fetchArticles) {
					window.vueInstance.$store.commit('sendingApiRequest', null)
					return false;
				}

				if(e.status == 200){
					data = self.convertData(e.responseText);
					returnFunction(data);
				}else{
					window.eventHub.$emit('promptError');
					return false;
				}
				}
			})
     	}
 		// If using live enviroment
 		else{

 			$.ajax({
	          type: "get",
	          url: postData.url,
	          dataType: dataType,
	          async: true,
            beforeSend: function(data) {
              if(fetchArticles)
                window.vueInstance.$store.commit('sendingApiRequest', data)
            },
	          success: function (data){
              if(fetchArticles)
                window.vueInstance.$store.commit('sendingApiRequest', null)

	          	data = self.convertData(data);
	          	returnFunction(data);

	          },
	          error: function(e){
              if(fetchArticles) {
                window.vueInstance.$store.commit('sendingApiRequest', null)
                return false
              }
	            if(e.status == 200){
	          		data = self.convertData(e.responseText);
	          		returnFunction(data);
	          	}else{
	          		window.eventHub.$emit('promptError');
		            return false;
	          	}
	          }
	        });

 		}

 	},

 	/*---------------------------------------*
		POSTER
	----------------------------------------*/

 	post: function(postData, returnFunction){

 		var self = this;

 		$.ajax({
	      type: "post",
	      url: postData.url,
	      dataType: 'json',
	      async: true,
	      data: postData.data,
	      success: function (data){

	      	data = self.convertData(data);
	      	returnFunction(data);

	      },
	      error: function(e){
	        if(e.status == 200){
	        	data = self.convertData(e.responseText);
	        	returnFunction(data);
	        }else{
	        	window.eventHub.$emit('promptError');
		        return false;
	        }
	      }
	    });

 	},


 	/*-------------------------------------------------*
		DATA
	-------------------------------------------------*/

	getSiteCart(returnFunction){

		const basketID = window.vueInstance.$store.state.basketID;

		if(!basketID){
			returnFunction(false);
			return;
		}

		var postData = {
			url: this.getWGUrl() + '/api/cart/get?locale=' + window.currentLangCodeExternal+'&id=' + basketID,
		}

		this.get(postData, function(data){
			returnFunction(data);
		},
			true
		);

	},

	changeSiteCartQty(returnFunction, failFunction, params){

		var postData = {
			data: {
				id: window.vueInstance.$store.state.basketID,
				item: params.item,
				rowIndex: params.rowIndex,
				quantity: params.qty
			},
			url: this.getWGUrl() + '/api/cart/update?locale=' + window.currentLangCodeExternal+'',
		}

		this.post(postData, function(data){
			returnFunction(data);
		});

	},

	getSavedWalls: function(returnFunction, wallData){

		var postData = {
			url: this.getWGUrl() + '/api/getSavedWalls?session=' + window.vueInstance.$localStorage.get('sessionID')
		}

		this.get(postData, function(data){
			returnFunction(data);
		}, true );

	},

	pictureWalls: function(returnFunction){

		var postData = {
			url: this.getWGUrl() + '/api/walls'
		}

		this.get(postData, function(data){
			returnFunction(data);
		}, true);
	},

	pictureWall: function(id, returnFunction){

		var postData = {
			url: this.getUrl() + '/shop?funk=get_article_configurator_ajax&format=json&configurator_id=' + id
		}

		this.get(postData, function(data){
			returnFunction(data);
		});
	},

	articlesWGR: function(returnFunction, queryData){

		var self = this

		// Get variables
		let fieldID = window.vueInstance.$store.state.currentWallField;
		let currentField = window.vueInstance.$store.state.pictureWall['articles'][fieldID-1];
		let sorting = window.vueInstance.$store.state.currentArticleSorting;

		let format = 'portrait';

		// If not default format
		if(typeof currentField.format != 'undefined')
			format = currentField.format;

		// Get chosen filter items to use in url
		var filterItems = window.filterMappingHandler.getCurrentFilterOptions();

		// Append the ones that belong to the current chosen slot (size and format)
		filterItems.push(window.filterMappingHandler.getIDFromSize(currentField.size));
		filterItems.push(window.filterMappingHandler.getIDFromFormat(format));

		// Method
		let method = "articles";
		var searchQuery = "";

		// Search
		if(window.vueInstance.$store.state.searchQuery){
			method = 'articles/search'
			searchQuery = "&searchQuery=" + window.vueInstance.$store.state.searchQuery;
		}

		// Build url
		let url = this.getWGUrl() + '/api/'+method+'?locale=' + window.currentLangCodeExternal+'&page=' + queryData.page + searchQuery;

		if(filterItems.length)
			url+= "&filterItems=" + filterItems.toString()

		let postData = {
			url: url
		}

		self.get(postData, function(data){
			self.commitArticleGet(data, queryData, returnFunction)
		}, true, 'json', true);

	},

	specificArticles: function(returnFunction, queryData){

		var self = this

		// Combinations
		let postData = {
			url: this.getWGUrl() + '/api/articlesExtended?locale=' + window.currentLangCodeExternal+'&productIDs=' + queryData.articles.toString()
		}

		self.get(postData, function(data){
			returnFunction(data);
		}, true, 'json', true);

	},

	commitArticleGet(data, queryData, returnFunction){
		window.vueInstance.$store.commit('articleFilter', data.filters);
		returnFunction(data);
	},

	frameswG(returnFunction, queryData){

		var self = this

		// Combinations
		let postData = {
			url: this.getWGUrl() + '/api/frames?locale=' + window.currentLangCodeExternal
		}

		self.get(postData, function(data){
			returnFunction(data);
		}, true, 'json', true);

	},

	backgrounds: function(returnFunction){

		var self = this;

		var postData = {
			url: self.getWGUrl() + '/api/backgrounds'
		}

		self.get(postData, function(data){

			// All our images are named in order for us to categorise them
			// Format: "id-color.jpg"

			// Background object
			var backgrounds = {};

			// Group into a associative structure
			$.each(data, function(){

				// Remove data
				var file = this.split('\\').pop().split('/').pop()
				var fileNoExt = file.replace(/\.[^/.]+$/, "")

				// Get id and color
				var id = fileNoExt.substr(0, fileNoExt.indexOf('-'))
				var color = fileNoExt.substr(fileNoExt.indexOf("-") + 1)

				// Add background to object if not exists
				if(typeof backgrounds[id] == 'undefined'){
					backgrounds[id] = {
						'id': id,
						'preview': id+"-"+window.appSettings.defaultBackground.key+".jpg",
						colors: {}
					}
				}

				// Add color to background
				backgrounds[id].colors[color] = file;

			});

			returnFunction(backgrounds);
		}, true);
	},

	colors: function(returnFunction){
		var colors = require('components/Dummy/colors.json');
		returnFunction(colors);
	},


	/*---------------------------------------*
		FUNCTIONS
	----------------------------------------*/

	buildChosenArticles: function(settings){

		var articles = [];
		var outOfStock = [];
		var checkStock = false;
		var includeFrames = true;

		if(typeof settings != 'undefined')
		{
			if(settings.checkStock)
				checkStock = true

			if(typeof settings.includeFrames != 'undefined' && !settings.includeFrames)
				includeFrames = false
		}

		// Build array with current articles
		$.each(window.vueInstance.$store.state.chosenArticles ,function(){

			if(typeof settings != 'undefined' && settings.checkStock)
				if(this.stock == 0)
					outOfStock.push(this)

			if(typeof(this.id) !== "undefined")
				articles.push(this.id);

		})

		// Frames
		if(includeFrames)
			$.each(window.vueInstance.$store.state.pictureWall.articles, function(index, article){

				// Check if article and frame is chosen for this field
				var chosenFrame = window.vueInstance.$store.state.chosenFrames[index + 1];

				// Check if article has required data
				if(article && typeof chosenFrame != 'undefined' && typeof chosenFrame.combinationID != 'undefined')

					articles.push(chosenFrame.combinationID)

					if(checkStock && chosenFrame && typeof chosenFrame['combinations'] != 'undefined')
						if(chosenFrame['combinations'][0].stock == 0)
							outOfStock.push(chosenFrame['combinations'][0])
			})

		$.each(outOfStock, function(index, value){

			var cartNoStock = window.vueInstance.$store.state.cartNoStock;
			cartNoStock.push(value);
			window.vueInstance.$store.commit('cartNoStock', cartNoStock);

		})

		if(outOfStock && typeof outOfStock[0] != 'undefined'){
			// Tell user that some products failed to add to cart
			window.eventHub.$emit('openModal', {
				modal: 'noStock',
			});
		}

		return articles

	},

	buy: function(returnFunction){

		var self = this;

		// Clear out of stock messages
		window.vueInstance.$store.commit('cartNoStock', []);

		// Start loading
		window.vueInstance.$store.commit('startLoading', 'buyButton');

		// Get articles
		var articles = this.buildChosenArticles({
			checkStock: true
		});

		// Check if there are any articles
		if(articles.length){

			// Basket ID
			const basketID = window.vueInstance.$store.state.basketID;

			// Postdata
			var postData = {
				items: articles.toString()
			}

			if(basketID){
				postData['id'] = basketID;
			}

			this.post({
				url: self.getWGUrl() + '/api/cart/add?locale=' + window.currentLangCodeExternal+'',
				data: postData,
			}, function(data){

				if(typeof data.cart != 'undefined' && data.cart)
					window.vueInstance.$store.commit('basketID', data.cart);

				returnFunction(data);
			});


		}
		// If there are no articles, open modal telling the person to add some
		else{
			window.vueInstance.$store.commit('stopLoading', 'buyButton');
			window.eventHub.$emit('promptError', window.vueInstance.$t("noProductsInBasket") )
		}

	},

	generateSaveData: function(data){

		// Get articles
		var articles = this.buildChosenArticles({frames: false});

		// Set article to each field
		var skus = [];
		$.each(window.vueInstance.$store.state.pictureWall.articles, function(index, value){

			if( typeof window.vueInstance.$store.state.chosenArticles[index +1] != 'undefined')
				skus.push(window.vueInstance.$store.state.chosenArticles[index +1].productID)
			else
				skus.push("")
		})

		// Get frames
		var framesToParse = window.vueInstance.$store.state.chosenFrames;
		var frames = [];

		$.each(framesToParse, function(index, value){
			frames.push(value.id)
		})

		// Information
		var information = {
			name: data.name,
			picture: data.picture,
			skus: skus,
			articles: window.vueInstance.$store.state.pictureWall.articles,
			frames: frames,
			pictureWallColor: window.vueInstance.$store.state.pictureWallColor,
			background: window.vueInstance.$store.state.background
		};

		// Save data to post
		var saveData =  JSON.stringify(information);

		return saveData;

	},

	save: function(returnFunction, data){

		var self = this;

		// Start loading
		window.vueInstance.$store.commit('startLoading', 'save');

		// Get basic save data
		var saveData = this.generateSaveData(data)
		var name = data.name
		var sessionID = window.vueInstance.$localStorage.get('sessionID');
		var info = JSON.parse(saveData);

		// Post
		var postData = {
			url: this.getWGUrl() + '/api/saveWall',
			data: {
				'settings': saveData,
				'session': sessionID,
			}
		}

		this.post(postData, function(data){

			window.vueInstance.$store.commit('currentWallID', {
				id: data.savedWall.id,
				identifier: data.savedWall.identifier,
			})
			window.vueInstance.$store.commit('stopLoading', 'save');
			window.vueInstance.$store.commit('updated', 0)
			window.vueInstance.$store.commit('wallPicture', info.picture)
			window.vueInstance.$store.commit('currentWallName', name)

			returnFunction(data);
		});

	},

	updateSave: function(returnFunction, data){

		var self = this;

		// Start loading
		window.vueInstance.$store.commit('startLoading', 'save');

		// Get basic save data
		var saveData = this.generateSaveData(data);
		var name = data.name
		var info = JSON.parse(saveData);

		// Set new data
		var identifiers = window.vueInstance.$store.state.currentWallID;

		var postData = {
			url: this.getWGUrl() + '/api/updateWall',
			data: {
				'settings': saveData,
				'id': identifiers.id,
				'identifier': identifiers.identifier,
			}
		}

		this.post(postData, function(data){
			window.vueInstance.$store.commit('stopLoading', 'save');
			window.vueInstance.$store.commit('wallPicture', info.picture)
			window.vueInstance.$store.commit('currentWallName', name)
			returnFunction(data);
		});

	},

	removeSave: function(returnFunction, data){

		var self = this;

		// Start loading
		window.vueInstance.$store.commit('startLoading', 'deleteSave' + data.id);

		var postData = {
			url: self.getUrl() + '/shop?funk=remove_article_configurator&id=' + data.id,
		}

		self.get(postData, function(data){
			window.vueInstance.$store.commit('stopLoading', 'deleteSave' + data.id);
			returnFunction(data);
		});

	},


	convertData(badstring){
		return badstring;
	}

};

window.apiHandler.getUrl();



// WEBPACK FOOTER //
// ./client/api.js